import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import ConsoleCard from './ConsoleCard';
import axios from 'axios';
import * as React from 'react';
import { LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';



function ConsoleList(props) {
  const [game_consoles, setGameConsoles] = React.useState([]);
  const [has_loaded, setHasLoaded] = React.useState(false);
  const cached_game_console_ids = []

  if (!has_loaded){
    let consoles = JSON.parse(localStorage.getItem("consoles"));

    if (consoles !== null) {
      console.log("loaded cache");
      for (const game_console of consoles) {
        const card = <ConsoleCard id={game_console["id"]} handleConsoleChange={props.handleConsoleChange} />
        cached_game_console_ids.push(card);
      }
      setGameConsoles(cached_game_console_ids);
      setHasLoaded(true);
    } else {
      console.log("making requests");
      axios.get('https://retrodb.djalim.fr/consoles').then((result) => {
        for (const game_console of result.data) {
          localStorage.setItem("consoles",JSON.stringify(result.data));
          console.log(game_console["id"]);
          const card = <ConsoleCard id={game_console["id"]} handleConsoleChange={props.handleConsoleChange} />
          cached_game_console_ids.push(card);
        }
        setGameConsoles(cached_game_console_ids);
        setHasLoaded(true);
      })

    }
  }


  if (!has_loaded){
    return (
      <div style={{display: "flex", flexWrap:"wrap", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
        <LinearProgress />
      </div>
    );
  }
  else{ 
    return (
      <Box 
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="center"
        flex="1 0 21%"
        alignItems="center"
        gap={1}
        p={2}
        sx={{
        }}>
        {game_consoles}
      </Box>
    );
  }
}

export default ConsoleList;
